module.exports = __webpack_public_path__ + "static/media/5.6c7f7a9a.mp4";